import { useEffect, useState } from "react";
import React, { useRef } from 'react';

import { NavLink, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Grid, Box, Button, Card, Typography, useTheme  } from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

import './home.scss';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import { Pagination, Navigation, EffectCoverflow } from 'swiper/modules';

import { GetProjectLink, duplicateProject, duplicateTemplateProject} from './../../axios/ApiProvider';
import { Header } from '../../component/home-header/header';
import { Footer } from '../../component/home-footer/footer';
import { NewProjectPopup } from '../../component/empty-project/newProjectPopup'

//import HVideooTarget from '../../assets/image/home/VideooTarget.gif';
import PCMedia from '../../assets/image/home/pc-media.jpg';
import langMSS from '../../assets/image/home/langueMSS.jpg';
import PCMic from '../../assets/image/home/pc-mic.jpg';
import readyPlay from '../../assets/image/home/ready-play.jpg';

import VideooWatermark from '../../assets/image/home/videoo.png';
import VideooWatermarkLight from '../../assets/image/main-logo-black.png';
import SubtitlesEnglishTemplate from '../../assets/image/home/subtitlesenglishemplate.png';
import VideooEditor6 from '../../assets/image/home/Videoo-TextToSpeech.jpg'

export const HOME_FRONTEND_URL       = process.env.REACT_APP_BASE_FRONTEND_URL
export const EDIT_FRONTEND_URL       = process.env.REACT_APP_BASE_FRONTEND_EDITOR_URL
export const BASE_STATIC_STORAGE_URL = process.env.REACT_APP_STATIC_STORAGE_URL;
export const HomeVideoURL = {BASE_STATIC_STORAGE_URL} + '/videos/VideooHome.mp4';

export const HomeWelcomeImageURL = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddTransition-2-AddVideo.png'

export const HomeAddTextToSpeech = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddText-4-ChangeFont.png'
export const HomeAIBasedTextToSpeech = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddTransition-7-Exported.png'
export const HomeFreeStockVideos = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddFilter-5-NoFilter.png'

const VideooEditor1 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-Signup.jpeg'
const VideooEditor2 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-Pricing.jpeg'
const VideooEditor3 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-EditorPage.jpeg'
const VideooEditor4 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-Templates.jpeg'
const VideooEditor5 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-Subtitles.jpeg'
//const VideooEditor6 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-TextToSpeech.jpeg'
const VideooEditor7 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AIImage.jpeg'
const VideooEditor8 = BASE_STATIC_STORAGE_URL + '/images/features/Add%20Transition%20to%20Video.png'
const VideooEditor9 = BASE_STATIC_STORAGE_URL + '/images/features/Add%20Music%20to%20Video%202.png'
const VideooEditor10 = BASE_STATIC_STORAGE_URL + '/images/features/Add%20Text%20to%20Video.png'
const VideooEditor11 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddMusic-12-Extra-TTS.png'

const VideooEditor_AddImage_Welcome = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage.png'
const VideooEditor_AddImage_Step1 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-1-MainPage.png'
const VideooEditor_AddImage_Step2 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-2-SignupPage.png'
const VideooEditor_AddImage_Step3 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-3-CreateBlankProject.png'
const VideooEditor_AddImage_Step4 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-4-CreateProjectFromTemplates.png'
const VideooEditor_AddImage_Step5 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-5-CreateProjectFromStock.png'
const VideooEditor_AddImage_Step6 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-6-MediaMenu.png'
const VideooEditor_AddImage_Step7 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-7-AddSecondImage.png'
const VideooEditor_AddImage_Step8 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-8-SearchStockSound.png'
const VideooEditor_AddImage_Step9 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-9-AddAStockSoundPopup.png'
const VideooEditor_AddImage_Step10 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-10-AddStockSound.png'
const VideooEditor_AddImage_Step11 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-11-Export.png'
const VideooEditor_AddImage_Step12 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-12-ExportResult.png'
const VideooEditor_AddImage_Step13 = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-AddImage-14-Trimmer-Resizer-Rotator-Filters.png'

const VideooEditor_AddImage_PexelsVideo = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-PexelsVideo.png'
const VideooEditor_AddImage_PixabayVideo = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-PixabayVideo.png'
const VideooEditor_AddImage_FreeSoundAudio = BASE_STATIC_STORAGE_URL + '/images/features/Videoo-FreeSoundAudio.png'

const VideooEditor_AddTransitions_Image = BASE_STATIC_STORAGE_URL + '/images/features/Add%20Transition%20to%20Video.png'
const VideooEditor_AddMusic_Image = BASE_STATIC_STORAGE_URL + '/images/features/Add%20Subtitle%20to%20Video.png'
const VideooEditor_AddText_Image = BASE_STATIC_STORAGE_URL + '/images/features/Add%20Text%20to%20Video.png'
const VideooEditor_AddStock_Image = BASE_STATIC_STORAGE_URL + '/images/features/Translate%20Video.png'

const Template1UUID = "6d5937df-785c-4be9-9520-57aac4bc381c";
const Template2UUID = "4e5800fc-a552-4a03-ab94-e0cdccac6d16";
const Template3UUID = "a79b0cdf-c1de-4b07-ab6d-b55bde832060";
const Template4UUID = "7b315109-a415-4e51-83c4-869b1dc5226a";

//import ButtonArrow from '../../assets/image/buttonarrow.png';
let mobileScreenDetect = false
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4))){
    mobileScreenDetect = true;
  }
/*const utubeVid = [
  {
    id:'749UBoxm9KE',
    title: 'How to Cut and Remove a part of a video using Videoo.io'
  },
  {
    id:'YA-h9z3xkz0',
    title: 'How to Export a Video Editor project with Videoo.io'
  },
  {
    id:'YJsGobOuAxo',
    title: 'How to Add Layers of a video using Videoo.io'
  },
  {
    id:'YxZEcRy3Yvw',
    title: 'How to Add AI generated Auto Subtitles using Videoo.io'
  },
  {
    id:'QDBdhiLsw5g',
    title: 'How to Add Text and Titles to a video with Videoo.io'
  },
  {
    id:'JfpogS4KnSk',
    title: 'How to Add Text to Speech using AI Voices with Videoo.io'
  },
  {
    id:'LA6CZ-m04Dw',
    title: 'How to add transitions to a video using Videoo.io'
  },
  {
    id:'LDxRLUspHMg',
    title: 'How to Join/Merge two videos using Videoo.io'
  },
  {
    id:'iTUfDPTr8Ak',
    title: 'How to change video resolution using Videoo'
  },
  {
    id:'n4q43YDk1fc',
    title: 'How to Add a new Asset (Image, Video, Emoji or Stock Videos) to a Video Project using Videoo.io'
  },
 
]*/

export const Home = () => {
  const loginState = useSelector((store) => store.maindata.loginState);
  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  const [popUp, setPopUp] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const theme = useTheme()
  // We host the video on our own server, so we can use a ref to access it
  const videoRef = useRef(null);
  const togglePlayPause = () => {
    const video = videoRef.current;
    // Toggle between play and pause based on the video's current state
    if (video.paused) {
      video.play();
      setIsPlaying(true); // The video is now playing, so we set isPlaying to true
    } else {
      video.pause();
      setIsPlaying(false); // The video is paused, so we set isPlaying to false
    }
  };

  const handleVideoClick = () => {
    togglePlayPause();
  };
  
  const handleClickTemplateDuplicate = async (uuid) => {
    if (!uuid ) return

    let result = await duplicateTemplateProject(uuid)
    if (result.state !== 'success') {
      return
    }

    let data = result.data

    // Check if access was denied
    if (data['Code'] === "Access Denied") {
      console.error("Cannot create template project: Access Denied");
      return;
    }

    console.log("Duplicated Project uuid: ", data['Duplicated Project uuid'])

    let duplicateUUID = data['Duplicated Project uuid']
    window.location.href = `${EDIT_FRONTEND_URL}/${duplicateUUID}/`
  }

  useEffect(() => {
    console.log('loginState', loginState);
    let item = localStorage.getItem('user_data')
    let tempData = {}
    if (!!item && JSON.parse(item)?.state === 'loggedin') tempData = JSON.parse(item)
    if (loginState) {
      console.log("Redirecting to dashboard" + `${HOME_FRONTEND_URL}/dashboard/projects`);
      window.location.href = `${HOME_FRONTEND_URL}/dashboard/projects`
    }
  }, [loginState])

 const handleCreateNewProject = async () => {
    let result = await GetProjectLink();
    if (!result || result.state == 'error') window.toastr.error(result.data.message);
    else if (!!Object.keys(result.data)[0]) window.location.href = `${EDIT_FRONTEND_URL}/${Object.keys(result.data)[0]}?from=new`
  }

  const cardTemplateData = [
    {
      id: 1,
      uuid: Template1UUID,
      image: VideooEditor_AddMusic_Image,
      text: languageStrs.try_autosubtitles_in_english,
    },
    {
      id: 2,
      uuid: Template2UUID,
      image: VideooEditor_AddText_Image,
      text: languageStrs.try_translations_in_turkish,
    },
    {
      id: 3,
      uuid: Template3UUID,
      image: VideooEditor_AddStock_Image,
      text: languageStrs.try_subtitles_in_spanish,
    },
    {
      id: 4,
      uuid: Template4UUID,
      image: VideooEditor_AddTransitions_Image,
      text: languageStrs.try_ai_video_summary,
    },
  ];  

  const videoTools = [
    {
      id: 1,
      title: "Add Image to Video",
      image: VideooEditor8,
      link: "../add-image-to-video"
    },
    {
      id: 2,
      title: "Add Music to Video",
      image: VideooEditor9,
      link: "../add-music-to-video"
    },
    // {
    //   id: 3,
    //   title: "Add Text to Video",
    //   image: VideooEditor10,
    //   link: "../add-text-to-video"
    // },
    {
      id: 4,
      title: "Add Free Stock Content to Video",
      image: VideooEditor11,
      link: "../add-free-stock-to-video"
    }
  ];
  const videoFeaturesData = [
    {
      id: 1,
      image: VideooEditor5,
      title: "Translate Subtitles and Audio",
      description: "VIDEOO offers powerful translation features for subtitles and audio, making your content accessible globally.",
      features: [
        "AI-Generated Subtitle Translations: Translate subtitles into multiple languages with a single click.",
        "AI-Generated Audio Translations: Generate natural-sounding voices in different languages.",
        "Multi-Language Dual Subtitles: Add subtitles in two languages simultaneously.",
        "Seamless Integration: Easily translate and edit subtitles and audio within the workflow."
      ],
      buttonText: "Try Now!",
      buttonLink: null, 
      onClick: () => handleCreateNewProject(),
    },
    {
      id: 2,
      image: VideooEditor4,
      title: "Tailor Made Templates",
      description: "VIDEOO offers tailor-made templates to simplify the video editing process for social media creators.",
      features: [
        "Platform-Specific Designs: Optimized for Instagram, TikTok, YouTube, and Facebook.",
        "Customizable Elements: Easily adjust colors, fonts, and text to match your brand.",
        "Pre-Set Animations and Effects: Apply professional animations with a single click.",
        "Industry-Specific Templates: Options for beauty, fashion, travel, food, fitness, and more.",
        "AI-Enhanced Customization: AI suggests optimal color schemes, fonts, and layouts.",
        "Regular Updates: New templates added regularly to keep up with trends.",
        "These templates help users create high-quality, engaging videos quickly and easily."
      ],
      buttonText: "Learn More!",
      buttonLink: "../dashboard/templates",
    },
    {
      id: 3,
      image: VideooEditor6,
      title: "AI Voices (Text-to-Speech)",
      description: "VIDEOO uses advanced AI to enhance your videos with high-quality voices and images.",
      features: [
        "AI Voices (TTS): Generate professional, human-like voices for your videos.",
        "Powered by Voiser.net & Google: Videoo.io supports 50+ languages, with 250+ different voices.",
        "Voice Options: Change pitch, speed and volume to suit your video.",
        "Seamless Integration: Easily add AI-generated voices which are indistinguishable from real human voices."
      ],
      buttonText: "Try Now!",
      buttonLink: null, 
      onClick: () => handleCreateNewProject(),
    },
    {
      id: 4,
      image: VideooEditor7,
      title: "AI Generated Images",
      description: "AI-Generated Visuals with VIDEOO",
      features: [
        "AI-Generated Visuals with VIDEOO",
        "Automated Image Creation: Generate high-quality images with a click.",
        "Customizable Visuals: Easily match visuals to your brand's style.",
        "Diverse Styles: Select from various themes to suit your video’s tone.",
        "Enhanced Creativity: AI suggests new visual ideas and concepts.",
        "Time-Saving: Focus more on content, less on design."
      ],
      buttonText: "Try Now!",
      buttonLink: null, 
      onClick: () => handleCreateNewProject(),
    },
];

  const staticFeaturesData = [
    {
      id: 1,
      title: languageStrs.online_collaborative_video_editing,
      description: languageStrs.online_collaborative_video_editing_detail,
      image: HomeAddTextToSpeech,
    },
    {
      id: 2,
      title: languageStrs.auto_subtitles_translations,
      description: languageStrs.auto_subtitles_translations_detail,
      image: SubtitlesEnglishTemplate,
    },
    {
      id: 3,
      title: languageStrs.ai_base_text_speech,
      description: languageStrs.ai_base_text_speech_detail,
      image: HomeAIBasedTextToSpeech,
    },
    {
      id: 4,
      title: languageStrs.free_user_stock_video,
      description: languageStrs.free_user_stock_video_detail,
      image: HomeFreeStockVideos,
    },
  ]; 
  
  const faqData = [
    {
      id: 1,
      question: "What are the best practices for editing videos for social media?",
      answer: "When editing videos for social media, consider the platform's preferred video dimensions, keep the content concise and engaging, and use captions to ensure accessibility. Additionally, leverage trending music and effects to enhance viewer engagement.",
    },
    {
      id: 2,
      question: "How can I improve the quality of my video edits?",
      answer: "To improve video quality, use high-resolution footage, ensure proper lighting, and utilize video stabilization tools. Color correction and grading can also significantly enhance the visual appeal of your videos.",
    },
    {
      id: 3,
      question: "What software should beginners use for video editing?",
      answer: "You should consider user-friendly software like Videoo.io, iMovie, Capcut, Kapwing, InVideo, Veed or Adobe Premiere Pro. These platforms offer intuitive interfaces and essential features that are easy to learn and use.",
    },
    {
      id: 4,
      question: "How can AI tools help in video editing?",
      answer: "AI tools can automate repetitive tasks like creating subtitles, translating audio, generating visuals, and applying effects. This not only saves time but also enhances the overall quality and creativity of the video.",
    },
    {
      id: 5,
      question: "What are the benefits of collaborative video editing?",
      answer: "Collaborative video editing allows multiple users to work on the same project simultaneously, increasing productivity and fostering creative input. It also streamlines the feedback process and ensures a cohesive final product.",
    },
    {
      id: 6,
      question: "How do I choose the right background music for my video?",
      answer: "When selecting background music, consider the tone and message of your video. Use royalty-free music to avoid copyright issues, and ensure the music complements your content without overpowering the narration or dialogue.",
    },
    {
      id: 7,
      question: "What export settings should I use for the best video quality?",
      answer: "For the best quality, export videos in MP4 (H.264) format with a resolution of at least 1080p. Use a bitrate of 10-15 Mbps for HD content and 30-50 Mbps for 4K. Adjust settings based on the platform you’re uploading to.",
    },
    {
      id: 8,
      question: "How can I make my videos more engaging?",
      answer: "To make your videos more engaging, use a strong hook in the first few seconds, incorporate dynamic cuts and effects, add captions for accessibility, and keep the pacing fast to maintain viewer interest.",
    },
  ];
  
  
  return (

    <Box className="T_containner">

      <Box className={`Header ${theme.palette.mode === "dark" ? "dark" : "light"}`}><Header /></Box>

      <Box className="content-containner">
        <Box className="section-15"> 
          <Box className="div-1232">
            <Grid container spacing={1} justifyContent={'center'} alignItems={'center'}>
              <Grid item xs={12} md={6}>
                  <Box className="mb-6" sx={{ width: '100%', maxWidth: { md: '100%', sm: '70%', xs: '60%' }, padding: 0, marginInline: 'auto' }}>
                    <img 
                    loading="lazy"
                    src={theme.palette.mode === "dark" ? VideooWatermark : VideooWatermarkLight}
                    style={{
                      opacity: 0,
                      transition: "opacity 0.3s ease-in-out",
                    }}
                    onLoad={(e) => e.target.style.opacity = 1}
                  />
                  </Box>

                  <Grid container justifyContent={'center'} alignItems={'center'}>
                    <Box className="mb-6">
                      <Typography
                      sx={{textAlign: 'center', typography: { xl: 'h2', lg: 'h3', md: 'h4', sm: 'h3', xs: 'h4' }}}
                      gutterBottom fontWeight={'bold !important'}
                      alignItems={'center'}
                      >
                      {languageStrs.online_ai_video_editor}
                      </Typography>
                    </Box>

                    <Box className="hs5-content" style={{ textAlign: 'center' }}>
                      <Typography
                      sx={{textAlign: 'center', typography: { xl: 'h4', lg: 'h5', md: 'h6', sm: 'h5', xs: 'subtitle1' }}}
                      gutterBottom
                      >
                      {languageStrs.home_create_button_detail}
                      </Typography>
                    </Box>

                    <Box className="hs1-content">
                      <Typography
                      sx={{textAlign: 'center', typography: { xl: 'h4', lg: 'h5', md: 'h6', sm: 'h5', xs: 'subtitle1' }}}
                      gutterBottom
                      >
                        <NavLink to='/dashboard/templates' className="trysamplebtn">
                        {languageStrs.home_templates_start}. <NavigateNextIcon />
                        </NavLink>
                      </Typography>
                    </Box>

                  </Grid>
                    <Box className="section-15"> 
                      <Box className="div-1232" justifyContent={'center'}>
                        <Grid container justifyContent={'center'} alignItems={'center'}>
                          <Grid item>
                              <Box className="uploadbtn">
                                <Box className="mb-6" justifyContent={'center'} sx={{ width: '100%', maxWidth: '100%', padding: 0, margin: 0 }}>
                                  <Button
                                  variant="contained"
                                  className="py-10 px-60 create-new-video-btn"
                                  sx={{color: "#fff", typography: { xl: 'h1', lg: 'h2', md: 'h3', sm: 'h4', xs: 'h5'}, borderRadius: "50px"}}
                                  onClick={handleCreateNewProject}
                                  >
                                  {languageStrs.create_now}
                                  </Button>
                                </Box>
                              </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>

              </Grid>
              <Grid item xs={12} md={6}  sx={{ width: '100%', maxWidth: { md: '100%', sm: '80%', xs: '100%' }, padding: 0, marginInline: 'auto' }}>
                    <img 
                    loading="lazy"
                    src={HomeWelcomeImageURL}style={{
                      minWidth: "184px",
                      minHeight: "103px",
                      flexGrow: "unset",
                      opacity: 0,
                      transition: "opacity 0.3s ease-in-out",
                    }}
                    onLoad={(e) => e.target.style.opacity = 1}
                    />
              </Grid>

            </Grid>
          </Box>
        </Box>

        <Box className="section-9 directory">
          <Box>
            <Grid
              container
              spacing={{ xl: 3, lg: 2, md: 5, sm: 3, xs: 2}}
              maxWidth={1920}
              marginInline="auto"
              wrap="wrap"
              alignItems="stretch"
            >
              {cardTemplateData.map((card) => (
                <Grid
                  item
                  xl={3} 
                  lg={3} 
                  md={6} 
                  sm={6} 
                  xs={12} 
                  key={card.id}
                  onClick={() => handleClickTemplateDuplicate(card.uuid)}
                  display={'flex'}
                >
                  <Card className="py-6 px-10 cta-card" sx={{width: '100%'}}>
                    <Box
                    component={'img'}
                    sx={{
                      maxWidth: { xl: '100%', lg: '100%', md: '70%', sm: '70%', xs: '80%' }, 
                      marginInline: 'auto',
                      opacity: 0,
                      transition: "opacity 0.3s ease-in-out",
                    }}
                    src={card.image}
                    alt="Template"
                    onLoad={(e) => e.target.style.opacity = 1}
                    />
                    <Typography
                      className="text-center cta-text"
                      sx={{
                        typography: { xl: 'h4', lg: 'h5', md: 'h4', sm: 'h5' },
                        marginBottom: { xl: 3, lg: 3, md: 2, sm: 2, xs: 1 },
                        fontWeight: "600 !important"
                      }}
                    >
                      {card.text}
                    </Typography>
                  </Card>
                </Grid>
              ))}
            </Grid>

            </Box>
        </Box>

         <Box className="content-containner">
        <Box className="section-9 directory std-hero-section" sx={{ paddingY: '0rem' }}>
          <Box className="div-1232">
            <Box className="mx-auto text-center" sx={{ width: '80%' }}>
                <Typography gutterBottom sx={{
                  typography: { xl: 'h2', lg: 'h3', xs: 'h4' },
                }} fontWeight={600} marginBlock={'2%'}>
                  All tools with a single click!
                </Typography>
            </Box>
            <Box sx={{ display: "grid", gridTemplateColumns: {sm: "repeat(2, 1fr)", xs: "repeat(1, 1fr)"}, gap: 3, gridAutoRows: {lg: '1fr', xs: 'unset'} }}>
              {videoFeaturesData.map((feature, index) => (
                    <Box
                      key={index}
                      className={`feature-card ${theme.palette.mode === "dark" ? "dark" : "light"}`}
                      sx={{
                        display: "flex",
                        flexDirection: {lg: 'row', xs: 'column'},
                        alignItems: "center",
                        textAlign: "center",
                        height: "100%",
                        borderRadius: "20px",
                        overflow: "hidden",
                        gap: '2%',
                        padding: {lg: '0 3%', xs: '3%'}
                      }}
                    >
                    <Box sx={{width: {lg: '70%', xs: '100%'}, height: {lg: '90%',md: '350px', md: '300px', xs: '250px'}, display: 'flex', justifyContent: 'center'}}>
                      <img 
                      loading="lazy" 
                      height={"100%"} 
                      src={feature.image} 
                      alt={feature.title} 
                      style={{
                        borderRadius: "20px", 
                        objectFit: 'cover',
                        opacity: 0,
                        transition: "opacity 0.3s ease-in-out",
                        }}
                        onLoad={(e) => e.target.style.opacity = 1}
                      />
                    </Box>
                  
                    <Box sx={{ 
                      width: "100%", 
                      display: 'flex', 
                      flexDirection: 'column',
                      height: '100%', 
                    }}>
                      <Box>
                        <Typography sx={{typography: {xl: 'h3', lg: 'h4', md: 'h3', sm: 'h4', xs: 'h5'}}} marginTop={2} gutterBottom fontWeight={'600 !important'}>
                          {feature.title}
                        </Typography>

                        <Typography sx={{typography: {xl: 'h5', xs: 'h6'}}} gutterBottom align="left" marginBlock={3}>
                          {feature.description}
                        </Typography>

                        <Box display="flex" flexDirection="column" gap={1}>
                          {feature.features.map((text, i) => (
                            <Typography key={i} sx={{typography: {xl: 'body1', lg: 'body2', md: 'body1', xs: 'body2'}}} gutterBottom align="justify">
                              <strong>{i + 1}.</strong> {text}
                            </Typography>
                          ))}
                        </Box>
                      </Box>
                      <Box sx={{width: "100%", textAlign: "center"}}>
                      {feature.buttonLink ? (
                        <Button
                          to={feature.buttonLink}
                          component={Link}
                          variant="contained"
                          className="py-10 px-33 feature-learn-more-btn"
                          sx={{ borderRadius: 50, color: "#fff", fontSize: {xl: 18, sm: 14} }}
                        >
                          {feature.buttonText}
                        </Button>
                      ) : (
                        <Button
                          onClick={feature.onClick}
                          variant="contained"
                          className="py-10 px-33 feature-learn-more-btn"
                          sx={{ borderRadius: 50, color: "#fff", fontSize: {xl: 18, sm: 14} }}
                        >
                          {feature.buttonText}
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box className="content-container" sx={{paddingInline: '3%', margin: 0 }}>
          <Box className={mobileScreenDetect ? "h-section top-section mt-4" : "h-section top-section mt-5"}>
            <Box className="h-section-container">
              <Grid 
              display={'flex'}
              flexWrap={'wrap'}
              justifyContent={'space-between'}
              >
                {staticFeaturesData.map((feature) => (
                  <Grid key={feature.id} item md={6} sx={{flex: {md: '0 0 46%', xs: '0 0 100%'}}}>
                    <Typography
                    sx={{typography: { xl: 'h2', lg: 'h3', sm: 'h4', xs: 'h5'}, height: '2lh'}}
                    className="heading-19 mb-2 text-center"
                    >
                    {feature.title}
                    </Typography>
                    <Box className="mb-6" sx={{width: '100%', height: '24rem'}}>
                      <Box 
                      component={'img'} 
                      sx={{
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'cover',
                        opacity: 0,
                        transition: "opacity 0.3s ease-in-out",
                      }} 
                      src={feature.image} 
                      alt={feature.title}
                        onLoad={(e) => e.target.style.opacity = 1}
                      />
                    </Box>
                    <Typography className="hs1-content2" sx={{typography: {lg: 'h4', sm: 'h5', xs: 'subtitle1'}}}>{feature.description}</Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </Box>

        <Box className="section-9 directory" sx={{paddingY: '0rem'}}>
          <Box className="div-1232">
            <Box>
              <Typography
              className="text-center"
              sx={{typography: {lg: 'h2', sm: 'h3', xs: 'h4'}, fontWeight: '600 !important'}}
              gutterBottom
              fontWeight={600}
              >
              Other Video Tools
              </Typography>
            </Box>
            <Box className="text-center">
              <Typography
              className="text-center"
              sx={{typography: {lg: 'h3', sm: 'h4', xs: 'h5'}}}
              gutterBottom 
              >
              There are plenty of other features that are avaliable with Videoo.io
              </Typography>
            </Box>
          </Box>
          <Box>
            <Grid
            display={'flex'}
            justifyContent={'center'}
            gap={2}
            maxWidth={1920}
            marginInline={"auto"}
            flexWrap={'wrap'}
            >
              {videoTools.map(tool => {
                return (
                  <Grid key={tool.id} item md={4} xs={12} sx={{width: {lg: '32%', sm: '47%', xs: '100%'}}}>
                    <Card className="tool-card p-10" sx={{ display: "flex", flexDirection: "column", height: "100%"}}>
                      <Grid>
                        <img 
                        loading="lazy" 
                        width={"100%"} 
                        src={tool.image} 
                        alt={tool.title} 
                        style={{
                          height: 300, 
                          objectFit: 'contain',
                          opacity: 0,
                          transition: "opacity 0.3s ease-in-out",
                          }}
                          onLoad={(e) => e.target.style.opacity = 1}
                        />
                      </Grid>
                      <Typography
                        component={Link}
                        to={tool.link}
                        className="mx-auto"
                        variant="h4"
                        fontWeight={500}
                        sx={{ textAlign: "center", display: "block" }}
                      >
                        {tool.title}
                      </Typography>
                      {/* <Box className="mx-auto text-center">
                        <Button to={tool.link} component={Link}>
                          Create
                        </Button>
                      </Box> */}
                    </Card>
                  </Grid>
                )
              })}
            </Grid>
          </Box>
        </Box>

        <Box className="section-9 directory" sx={{paddingY: '3rem'}}>
          <Box className="div-1232 px-18">
            <Box className="text-center">
              <Typography
              sx={{typography: {lg: 'h2', sm: 'h3', xs: 'h4'}, fontWeight: '600 !important'}}
              gutterBottom
              fontWeight={600}
              >
              Frequently Asked Questions About Video Editing
              </Typography>
            </Box>
            <Box className="text-justify mx-auto" sx={{marginBottom: '3rem', width: '80%'}}>
              <Typography sx={{typography: {lg: 'h3', sm: 'h4', xs: 'h5'}}} gutterBottom >
              Welcome to our FAQ section on video editing! Here, we address the most common questions and provide helpful insights to enhance your video editing skills. Whether you're a beginner or an experienced editor, you'll find valuable tips and best practices to create stunning videos.
              </Typography>
            </Box>
            <Box className="faq-container" display={'flex'} flexWrap={'wrap'} justifyContent={'space-between'}>
              {faqData.map((faq, index) => (
                <Box key={faq.id} className="py-10" sx={{flex: {sm: '0 0 46%', xs: '0 0 90%', marginInline: 'auto'}}}>
                  <Typography sx={{typography: {lg: 'h4', sm: 'h5', xs: 'h6'}, fontWeight: '600 !important'}} gutterBottom align="center">
                    Question #{index + 1}
                  </Typography>
                  <Typography sx={{typography: {lg: 'h4', sm: 'h5', xs: 'h6'}, textDecoration: 'underline'}} gutterBottom align="center">
                    {faq.question}
                  </Typography>
                  <Typography sx={{typography: {lg: 'h5', sm: 'body1', xs: 'body2'}}} gutterBottom align="justify">
                    Answer #{index + 1}: {faq.answer}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        <Box className="section-9 directory std-hero-section">
          <Box className="section-15 mx-auto">
            <Box className="div-1232">
              <Box className="mx-auto" >
                <Typography
                sx={{width: '80%', textAlign: 'center', marginX: 'auto', typography: {lg: 'h1', md: 'h2', sm: 'h3', xs: 'h4'}, fontWeight: '700 !important'}}
                gutterBottom
                >
                Make Your Social Media Videos Easily
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      </Box>


      <Box className="content-containner" >
        <Box className={mobileScreenDetect? 'h-section top-section mt-4' : 'h-section top-section mt-5'} >
          <Box className="h-section-container">

            <Box className="content-containner">
              
                  <Grid container spacing={0} paddingX={'3%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                    <Grid item md={6} display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                      <Box className="mb-6">
                        <Typography sx={{typography: {lg: 'h2', sm: 'h3', xs: 'h4'}}} align="center">
                          {languageStrs.online_ai_video_editor}
                        </Typography>
                      </Box>
                      <Box className="mb-6">
                        <img
                        loading="lazy" 
                        src={theme.palette.mode === "dark" ? VideooWatermark : VideooWatermarkLight} 
                        style={{
                          opacity: 0,
                          transition: "opacity 0.3s ease-in-out",
                          }}
                          onLoad={(e) => e.target.style.opacity = 1}
                        />
                      </Box>
            
                      {/* <div style={{ width: '100%', paddingTop: '56.25%', position: 'relative' }}> 
                        <iframe
                          src="https://www.youtube.com/embed/pXRjZ_RTnsM?si=RM-VXMRHFUQd9RHO"
                          title="Videoo.io, Online Cloud Based Video Editor"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                        ></iframe>
                      </div> */}
                      {/* {
                      <div className="video-container">
                        <video
                          ref={videoRef}
                          className="w-full"
                          src={`${BASE_STATIC_STORAGE_URL}/videos/VideooHome.mp4`}
                          onClick={togglePlayPause}
                          loop
                          poster={`${BASE_STATIC_STORAGE_URL}/videos/VideooIrmaSS-1080.jpg`}
                          preload="none"
                        />
                        {!isPlaying && (
                          <button className="play-button" onClick={(e) => {
                            // Prevent the video's onClick event from firing when the button is clicked
                            e.stopPropagation();
                            togglePlayPause();
                          }}>
                            <svg width="80" height="80" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8 5v14l11-7z" fill="currentColor"/>
                            </svg>
                          </button>
                        )}
                      </div>} */}

                    </Grid>
                    <Grid item md={6}>

                      <Typography align="center" sx={{typography: {lg: 'h2', sm: 'h3', xs: 'h4'}}} gutterBottom>
                      {languageStrs.home_free_trial_detail}
                      </Typography>
                      <Typography align="center" sx={{typography: {lg: 'h4', sm: 'h5', xs: 'body1'}}} gutterBottom>
                      {languageStrs.home_create_button_detail}
                      </Typography>
                      <Typography 
                        sx={{typography: {lg: 'h5', sm: 'h6', xs: 'body2'}}}
                        gutterBottom
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}>
                        <NavLink to='/dashboard/projects' className="trysamplebtn">
                        {languageStrs.home_templates_start} <NavigateNextIcon />
                        </NavLink>
                      </Typography>

                      <Box className="main-hero-cta">
                        <Box className="uploadbtn"
                          onClick={handleCreateNewProject}
                        >
                          {languageStrs.create_now}
                        </Box>
                        
                      </Box>

                    </Grid>
                  </Grid>  

            </Box>
            
          </Box>
        </Box>
      </Box>


      

      {/* <Box className="content-containner">
        <Grid container spacing={2} padding={2} justifyContent="center">
          <Grid item xs={10}>
            <Swiper
              slidesPerView={'auto'}
              centeredSlides={true}
              pagination={{
                clickable: true,
              }}
              loop={true}
              navigation={true}
              modules={[Pagination, Navigation, EffectCoverflow]}
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              effect={'coverflow'}
              grabCursor={true}
              className="mySwiper"
            >
              
                {utubeVid.map((item, key) =>  (
                  <SwiperSlide>
                    <div key={key}>
                      <iframe
                        key={key}
                        src={`https://www.youtube.com/embed/${item.id}`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                        style={{margin: 'auto', width: '100%', aspectRatio: 1.7}}
                        
                      />
                      <Typography variant="h5" component="h2" gutterBottom style={{textAlign: 'center'}}>{item.title}</Typography>
                    </div>
                  </SwiperSlide>
                ))}
              
            </Swiper>
            
          </Grid>
          
          
        </Grid>
      </Box> */}
      {/* <Box className="content-containner">
        <Box className="h-section top-section">
            <Box className='wf-section'>
                <Box className='div-1232'>
                    <Box className='div-block-67'>
                        <h2 className="heading-19">Videoo.io: Redefining Video Editing for the Future</h2>

                        <Box className='text-section-block'>
                            <ul className='text-section-ul'>
                                <li className='py-10'>
                                Our Collaborative Video Editing Software fosters teamwork and unleashes creativity, paving the way for the future of editing. The 4K Video Editing Software Online is tailored to meet the needs of beginners and professionals and offers a versatile tool for both groups. Take advantage of a high-resolution video export tool that ensures your content looks as brilliant as possible.
                                Videoo.io provides YouTubers and Influencers with HDR Video Editing Software and cloud-based workspaces tailored to their success. Video Editing Templates for Quick Production are a vital feature of our platform, streamlining your workflow for rapid content creation.
                                </li>
                                <li className='py-10'>
                                We provide a dynamic platform for creators of all levels at Videoo.io, an online collaborative video editing platform that is a breakthrough in online collaborative video editing. Our state-of-the-art 4K Video Editing Online tool ensures your content stands out in breathtaking detail. Movie Maker Online Video Editing Software allows you to collaborate effortlessly online, bringing cloud-based efficiency to your fingertips.
                                </li>
                                <li className='py-10'>
                                The Videoo.io platform enables you to explore a revolution in video editing, where innovation knows no bounds. Unlock your creativity with cloud-based editing and 4K resolution.
                                </li>
                            </ul>
                        </Box>

                    </Box>
                </Box>
            </Box>
        </Box>
      </Box> */}
      <Box className="footer-containner"><Footer /></Box>

      <NewProjectPopup popUp={popUp} setPopUp={setPopUp} />
    </Box>
  )
}